import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { META_COLLECT_API } from '../../../api';
import GeneralMap from '../../../components/Map/GeneralMap';
import { PageHeader } from '../../../components/PageHeader';
import { useSigninContext } from '../../../context/AuthProviderPages/Signin';
import { usePageContext } from '../../../context/usePage';
import { ContainerPage, PageContent } from '../../../styles/global.styles';
import { Line } from '../../../types/Line';
import SidebarLines from './SidebarLines';
import * as S from './styles';

const getRandomColor = () =>
  `#${Math.floor(Math.random() * 16777215)
    .toString(16)
    .padStart(6, '0')}`;

const Localizacao = () => {
  const { setSelectedPage } = usePageContext();
  const { path } = useSigninContext();
  const [lines, setLines] = useState<Line[]>([]);
  const [selectedLineIds, setSelectedLineIds] = useState<number[]>([]);
  const [lineColors, setLineColors] = useState<{ [key: number]: string }>({});
  const [showInactiveLineIds, setShowInactiveLineIds] = useState<number[]>([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  useEffect(() => {
    setSelectedPage({ option: 'localizacao' });
  }, []);

  useEffect(() => {
    if (path === '') return;

    META_COLLECT_API.get('/linha', { headers: { path } })
      .then(({ data }) => {
        const results: Line[] = Array.isArray(data) ? data : data.linhas || [];
        const linesWithTanks = results.filter(
          line => Number(line.DFQUANTIDADEDETANQUES) > 0,
        );

        setLineColors(prev => {
          const newColors = { ...prev };
          linesWithTanks.forEach(line => {
            const id = Number(line.DFIDLINHA);
            if (!newColors[id]) newColors[id] = getRandomColor();
          });
          return newColors;
        });

        setLines(linesWithTanks);
      })
      .catch(() => toast.error('Erro ao carregar as linhas'));
  }, [path]);

  const toggleArrayItem = (
    setter: React.Dispatch<React.SetStateAction<number[]>>,
    id: number,
  ) => {
    setter(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id],
    );
  };

  const handleColorChange = (id: number, color: string) => {
    setLineColors(prev => ({ ...prev, [id]: color }));
  };

  return (
    <>
      <PageHeader
        pageIcon={{ option: 'localizacao' }}
        pageTitle="Localização"
      />

      <ContainerPage>
        <PageContent
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            height: 'calc(100vh - 180px)',
            gap: 0,
            overflow: 'hidden',
          }}
        >
          <S.SidebarWrapper isVisible={isSidebarVisible}>
            <S.ToggleSidebarButton
              onClick={() => setIsSidebarVisible(!isSidebarVisible)}
              isVisible={isSidebarVisible}
              title={isSidebarVisible ? 'Recolher menu' : 'Expandir menu'}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </S.ToggleSidebarButton>

            <S.SidebarContent isVisible={isSidebarVisible}>
              <SidebarLines
                lines={lines}
                onToggle={id => toggleArrayItem(setSelectedLineIds, id)}
                selectedIds={selectedLineIds}
                lineColors={lineColors}
                onColorChange={handleColorChange}
                showInactiveLineIds={showInactiveLineIds}
                onToggleInactive={id =>
                  toggleArrayItem(setShowInactiveLineIds, id)
                }
              />
            </S.SidebarContent>
          </S.SidebarWrapper>

          <S.MapSection>
            <GeneralMap
              lineIds={selectedLineIds}
              lineColors={lineColors}
              showInactiveLineIds={showInactiveLineIds}
              height="100%"
            />
          </S.MapSection>
        </PageContent>
      </ContainerPage>
    </>
  );
};

export { Localizacao };
